import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ILessonListItem } from '@lb/api/mylb/interfaces';
import { NotificationBaseComponent } from './notification-base/notification-base.component';
import { TzDatePipe } from '@lb/pipes/timezone-aware-date.pipe';

/**
 * Learner notification: an instructor has submitted lesson grades and/or a lesson summary.
 * `data` is the lesson hydrated by Notification.Api from Lesson.Api; EntityID is the LessonID.
 */
@Component({
	standalone: true,
	imports: [CommonModule, NotificationBaseComponent, TzDatePipe],
	selector: 'lb-notification-lesson-grades-available',
	template: `<lb-notification-base [notification]="notification()">
		<div activity-message>
			Your grades and lesson summary are ready for the lesson on
			<b>
				{{ lesson()?.lessonDate | tzDate: 'MMM d' }} </b
			>.
		</div>
		<div activity-action>
			@if (lesson()) {
				<button type="button" md-button (click)="review()">Review</button>
			}
		</div>
	</lb-notification-base>`,
	styleUrls: ['./notification-base-shared.component.scss']
})
export class NotificationLessonGradesAvailableComponent extends NotificationBaseComponent {
	private readonly _router = inject(Router);

	lesson = computed(() => this.notification().data as ILessonListItem);

	review(): void {
		const lesson = this.lesson();
		if (!lesson) {
			return;
		}
		this._router.navigate(['/enrollments', lesson.enrollmentID, 'lessons', lesson.lessonID]);
	}
}
